import Chess from 'chess.js'

function getScoreReport(color, cp, score){
    let scoreReport = "";
    if (cp === "mate"){
        let mate = score;
        if (mate !== null){
            if (color === "b" && mate !== 0){
                mate = -1 * parseInt(mate);
            }
            scoreReport = "#" + (mate.toString());
        }
    }
    else{
        score = parseFloat(score) / 100;
        if (color === "b" && score !== 0){
            score = -1 * score
        }
        scoreReport = score.toString()
    }
    return scoreReport
}

function getVariationReport(board, moves){
    for (let i = 0; i < moves.length; i++){
        board.move(moves[i], { sloppy: true })
    }
    const sans = board.history()
    return sans.join(" ")
}

function sorting(a, b){
    let a_score = a.score;
    let b_score = b.score;
    let a_s = 0.0;
    let b_s = 0.0;
    if (a_score && a_score[0] === '#'){
        if(a_score.slice(1) !== 0){
            a_s = 1000 / parseFloat(a_score.slice(1));
        }
    }else{
        a_s = parseFloat(a_score);
    }
    if (b_score && b_score[0] === '#'){
        if(b_score.slice(1) !== 0){
            b_s = 1000 / parseFloat(b_score.slice(1));
        }
    }else{
        b_s = parseFloat(b_score);
    }
    if (a_s < b_s) return -1;
    if (a_s > b_s) return 1;
    return 0;
}

function sort_variations(variations){
    return variations.sort(sorting);
}

 export function parse(data, fen, engine, engine_name){
    const color = fen.split(" ")[1];
    let Variations = [];
    let depth = null;
    for (let i=data.length - 1; i >= 0; i--){
        const row = data[i];
        let json_var = {};
        let arr = row.split(" ");
        for( let index = 0; index < arr.length; index++){
            const item = arr[index];
            let board = new Chess(fen);
            if (item === "score"){
                json_var["score"] = getScoreReport(color, arr[index + 1], arr[index + 2])
            }
            else if (item === "nps"){
                json_var["nps"] = arr[index + 1]
            }
            else if (item === "pv"){
                json_var["pgn"] = getVariationReport(board, arr.slice(index + 1))
            }
            else if (item === "depth"){
                depth = arr[index + 1]
            }
        }
        Variations.push(json_var)
    }
    const json_data = {};
    json_data["depth"] = depth;
    json_data["engine"] = engine;
    json_data['initialFen'] = fen;
    json_data['engine_name'] = engine_name;
    json_data["format"] = "san";
    Variations = sort_variations(Variations);
    if (color === 'w'){
        Variations = Variations.reverse()
    }
    json_data["variations"] = Variations
    return json_data
  }